var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faCheckCircle, faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import getTranslation from '../../../../strings/i18n';
import { Inset, Stack } from 'syf-component-library/ui/spacing';
import getPromotionPercentage from '../../../../helpers/select-pay';
import createSelectPayRadioCardProps from '../../../../helpers/utils/select-pay-utils';
import useDeviceWidth from '../../../../hooks/use-device-width';
import useTriggerAnalyticsEvent from '../../../../hooks/use-trigger-analytics-event';
import { StyledTitle } from '../../../../styles/text';
import RadioOptionCard from '../../../common/radio-option-card';
import TermDetailsAccordion from '../../../common/term-details-accordion';
import OfferDetails from '../../offer-details';
import { StyledBackground, StyledInstallment } from '../../subcomponents';
import { StyledNotificationBar } from './subcomponents';
var SelectPayReviewInstallment = function (_a) {
    var installment = _a.installment;
    var t = getTranslation().t;
    var isMobile = useDeviceWidth();
    useTriggerAnalyticsEvent('selectPay.planReview');
    return (_jsxs(StyledBackground, { children: [_jsx(Inset, { top: isMobile ? 'base' : 'large', vertical: isMobile ? 'base' : 'xlarge', bottom: "small", children: _jsx(StyledNotificationBar, { type: "warning", icon: _jsx(FontAwesomeIcon, { icon: faExclamationTriangle }), title: t('selectPay.installmentsReviewDisclaimerText') }) }), _jsxs(StyledInstallment, { direction: "column", alignItems: "center", children: [_jsx(Stack, { size: isMobile ? 'medium' : 'large' }), _jsx(StyledTitle, { size: "large", weight: "semiBold", align: "center", children: t('selectPay.installmentsReviewHeading') }), _jsx(Stack, { size: isMobile ? 'medium' : 'large' }), _jsx(RadioOptionCard, __assign({}, createSelectPayRadioCardProps({
                        checked: true,
                        installment: installment,
                        icon: (_jsx(FontAwesomeIcon, { icon: faCheckCircle, size: "xl", color: "green" })),
                        onChange: function () { },
                        t: t
                    }), { details: _jsx(OfferDetails, { option: installment }) }))] }), _jsx(Stack, { size: "small" }), _jsx(TermDetailsAccordion, { header: t('selectPay.promotionalTermDetailsHeading'), installmentPercentage: getPromotionPercentage(installment) })] }));
};
export default SelectPayReviewInstallment;
//# sourceMappingURL=index.js.map